// Traduções PT/ES — escopo atual: tela de Login e tela de Cadastro de Empresas
// (index + abas). Chaves organizadas por tela; adicione novas telas como novos
// blocos de chaves, sem tocar no mecanismo (useT, abaixo em index.tsx).
import type { Language } from '../stores/useInterfaceStore';

export const translations: Record<Language, Record<string, string>> = {
  pt: {
    // ── Login ──────────────────────────────────────────────────────────────
    'login.title': 'Entrar',
    'login.subtitle': 'Acesse o painel de conformidade da sua empresa.',
    'login.usernameLabel': 'Usuário',
    'login.passwordLabel': 'Senha',
    'login.submitButton': 'Entrar',
    'login.or': 'ou',
    'login.forgotPassword': 'Esqueci a senha',
    'login.errorUsernameRequired': 'Usuário é obrigatório.',
    'login.errorPasswordRequired': 'Senha é obrigatória.',
    'login.errorPasswordMinLength': 'A senha deve ter no mínimo 3 caracteres.',
    'login.errorInvalidCredentials': 'Usuário ou senha inválidos.',
    'login.errorConnection': 'Falha ao conectar com o servidor. Verifique se o backend está rodando.',
    'login.errorGoogle': 'Não foi possível entrar com Google.',
    'login.brand': '4HC - Four Hands Group',
    'login.brandSub': '4Comply',
    'login.eyebrow': 'varredura de conformidade ativa',
    'login.heroTitle': 'Conformidade, auditorias e fornecedores em um só lugar.',
    'login.heroText': 'Acompanhe fornecedores, contratos e questionários de avaliação em um único painel, com trilha de auditoria completa em cada etapa.',
    'login.trust.tls': 'TLS 1.3',
    'login.trust.lgpd': 'CONFORME A LGPD',
    'login.trust.audited': 'SESSÃO AUDITADA',
    'login.langSwitcher.label': 'Idioma',

    // ── Cadastro de Empresas ─────────────────────────────────────────────────
    'companyRegistration.titleNew': 'Cadastro de Empresa',
    'companyRegistration.titleEdit': 'Editar Empresa',
    'companyRegistration.titleView': 'Visualização de Empresa',
    'companyRegistration.stepLabel': 'Passo {{step}} de {{total}}',
    'companyRegistration.readOnlyAlert': 'Modo somente leitura. Clique em "Editar" para alterar os dados ou em "Desativar" para inativar esta empresa.',
    'companyRegistration.inactiveAlertBefore': 'Esta empresa está ',
    'companyRegistration.inactiveAlertBold': 'inativa',
    'companyRegistration.inactiveAlertAfter': ' — não são permitidas alterações ou movimentações. Caso seja necessário reativá-la, o usuário DPO Master deve abrir um chamado.',

    'companyRegistration.tabs.dados': 'Dados',
    'companyRegistration.tabs.contatos': 'Contatos',
    'companyRegistration.tabs.enderecos': 'Endereços',
    'companyRegistration.tabs.licencas': 'Licenças',
    'companyRegistration.tabs.assinatura': 'Assinatura',
    'companyRegistration.tabs.dpo': 'Administrador',

    'companyRegistration.buttons.save': 'Salvar',
    'companyRegistration.buttons.backToList': 'Voltar para Listagem',
    'companyRegistration.buttons.edit': 'Editar',
    'companyRegistration.buttons.deactivate': 'Desativar',
    'companyRegistration.buttons.cancel': 'Cancelar',

    'companyRegistration.deactivateModal.title': 'Desativar Empresa',
    'companyRegistration.deactivateModal.text': 'Empresas inativas não poderão sofrer alterações ou movimentações. Informe a justificativa para a desativação.',
    'companyRegistration.deactivateModal.justificativaLabel': 'Justificativa',
    'companyRegistration.deactivateModal.justificativaPlaceholder': 'Descreva o motivo da desativação...',
    'companyRegistration.deactivateModal.confirm': 'Desativar',

    'companyRegistration.notify.razaoSocialRequired': 'Razão Social é obrigatória.',
    'companyRegistration.notify.cnpjInvalid': 'CNPJ inválido. Por favor, verifique o número informado.',
    'companyRegistration.notify.dpoNomeRequired': 'Nome do Administrador é obrigatório quando o campo está sendo preenchido.',
    'companyRegistration.notify.dpoEmailRequired': 'E-mail do Administrador é obrigatório quando o campo está sendo preenchido.',
    'companyRegistration.notify.updateSuccess': 'Empresa atualizada com sucesso!',
    'companyRegistration.notify.createSuccess': 'Empresa criada com sucesso! ID: {{id}}',
    'companyRegistration.notify.cnpjDuplicate': 'Este CNPJ já está cadastrado.',
    'companyRegistration.notify.saveError': 'Erro ao salvar empresa: {{error}}',
    'companyRegistration.notify.connectionError': 'Erro de conexão ao tentar salvar a empresa.',
    'companyRegistration.notify.deactivateSuccess': 'Empresa desativada com sucesso!',
    'companyRegistration.notify.deactivateError': 'Falha ao desativar a empresa.',
    'companyRegistration.notify.deactivateConnectionError': 'Erro de conexão ao desativar.',

    'companyRegistration.data.codigoId': 'Código ID Empresa',
    'companyRegistration.data.codigoIdPlaceholder': 'Será gerado automaticamente ao salvar',
    'companyRegistration.data.tipo': 'Tipo',
    'companyRegistration.data.tipoPlaceholder': 'Pesquisar no Cadastro Auxiliar de Tipos de Empresas',
    'companyRegistration.data.cnpj': 'CNPJ',
    'companyRegistration.data.cnpjInvalidFeedback': 'Por favor, insira um CNPJ válido',
    'companyRegistration.data.razaoSocial': 'Razão Social',
    'companyRegistration.data.nomeFantasia': 'Nome Fantasia',
    'companyRegistration.data.inscricaoEstadual': 'Inscrição Estadual',
    'companyRegistration.data.inscricaoMunicipal': 'Inscrição Municipal',
    'companyRegistration.data.ramoAtuacao': 'Ramos de Atuação',
    'companyRegistration.data.ramoAtuacaoPlaceholder': 'Pesquisar no Cadastro Auxiliar de Ramos de Atuação',
    'companyRegistration.data.regulamentacao': 'Regulamentação Setorial',
    'companyRegistration.data.regulamentacaoPlaceholder': 'Pesquisar no Cadastro Auxiliar de Regulamentações',
    'companyRegistration.data.dadosComplementares': 'Dados Complementares',
    'companyRegistration.data.createdSuccess': 'Cadastrado com sucesso!',
    'companyRegistration.data.createError': 'Erro ao cadastrar.',
    'companyRegistration.data.connectionError': 'Erro de conexão ao cadastrar.',

    'companyRegistration.contacts.nome': 'Nome',
    'companyRegistration.contacts.email': 'E-mail',
    'companyRegistration.contacts.telefone': 'Telefone',
    'companyRegistration.contacts.departamento': 'Departamento',
    'companyRegistration.contacts.selecione': 'Selecione',
    'companyRegistration.contacts.cargo': 'Cargo',
    'companyRegistration.contacts.saveChanges': 'Salvar Alterações',
    'companyRegistration.contacts.addContact': 'Adicionar Contato',
    'companyRegistration.contacts.cancel': 'Cancelar',
    'companyRegistration.contacts.tableActions': 'Ações',
    'companyRegistration.contacts.edit': 'Editar',
    'companyRegistration.contacts.remove': 'Remover',

    'companyRegistration.addresses.tipoEndereco': 'Tipo Endereço',
    'companyRegistration.addresses.tipoEnderecoPlaceholder': 'Pesquisar no cadastro Auxiliar Tipo Endereço',
    'companyRegistration.addresses.cep': 'CEP',
    'companyRegistration.addresses.endereco': 'Endereço',
    'companyRegistration.addresses.enderecoPlaceholder': 'Preenchido automaticamente após CEP',
    'companyRegistration.addresses.numero': 'Número',
    'companyRegistration.addresses.bairro': 'Bairro',
    'companyRegistration.addresses.cidade': 'Cidade',
    'companyRegistration.addresses.estado': 'Estado',
    'companyRegistration.addresses.saveChanges': 'Salvar Alterações',
    'companyRegistration.addresses.addAddress': 'Adicionar Endereço',
    'companyRegistration.addresses.cancel': 'Cancelar',
    'companyRegistration.addresses.tableActions': 'Ações',
    'companyRegistration.addresses.edit': 'Editar',
    'companyRegistration.addresses.remove': 'Remover',
    'companyRegistration.addresses.cepNotFound': 'CEP não encontrado.',
    'companyRegistration.addresses.cepError': 'Não foi possível consultar o CEP agora. Preencha o endereço manualmente.',
    'companyRegistration.addresses.selectCompanyFirst': 'Selecione uma empresa antes de cadastrar.',
    'companyRegistration.addresses.createdSuccess': 'Cadastrado com sucesso!',
    'companyRegistration.addresses.createError': 'Erro ao cadastrar.',
    'companyRegistration.addresses.connectionError': 'Erro de conexão ao cadastrar.',

    'companyRegistration.dpo.alertTitle': 'Administrador do Sistema',
    'companyRegistration.dpo.p1': 'Ao salvar a empresa, o sistema criará automaticamente um usuário com perfil ',
    'companyRegistration.dpo.perfilAdministrador': 'Administrador',
    'companyRegistration.dpo.p2': ' vinculado ao e-mail informado abaixo e enviará uma ',
    'companyRegistration.dpo.senhaTemporaria': 'senha temporária',
    'companyRegistration.dpo.p3': ' para esse endereço. O Administrador usará essa senha para o primeiro acesso e, a partir daí, fará os demais cadastros necessários.',
    'companyRegistration.dpo.nome': 'Nome *',
    'companyRegistration.dpo.nomePlaceholder': 'Nome completo do Administrador',
    'companyRegistration.dpo.email': 'E-mail *',
    'companyRegistration.dpo.emailPlaceholder': 'email@empresa.com.br',
    'companyRegistration.dpo.emailInvalid': 'E-mail inválido.',
    'companyRegistration.dpo.emailHelp': 'Este e-mail será usado como login do Administrador da empresa.',
    'companyRegistration.dpo.telefone': 'Telefone',
    'companyRegistration.dpo.telefonePlaceholder': '(00) 00000-0000',
    'companyRegistration.dpo.departamento': 'Departamento',
    'companyRegistration.dpo.selecione': 'Selecione',

    'companyRegistration.licenses.readOnlyAlert': 'Visualização somente leitura. O gerenciamento de licenças é exclusivo do usuário 4Comply.',
    'companyRegistration.licenses.tipo': 'Tipo da Licença',
    'companyRegistration.licenses.status': 'Status da Licença',
    'companyRegistration.licenses.modulos': 'Módulos',
    'companyRegistration.licenses.servicos': 'Serviços',
    'companyRegistration.licenses.mentoria': 'Mentoria',
    'companyRegistration.licenses.ativa': 'Ativa',
    'companyRegistration.licenses.inativa': 'Inativa',
    'companyRegistration.licenses.add': 'Adicionar',
    'companyRegistration.licenses.tableActions': 'Ações',
    'companyRegistration.licenses.empty': 'Nenhuma licença cadastrada.',
    'companyRegistration.licenses.remove': 'Remover',

    'companyRegistration.subscription.loading': 'Carregando planos...',
    'companyRegistration.subscription.currentTitle': 'Assinatura Atual',
    'companyRegistration.subscription.plan': 'Plano:',
    'companyRegistration.subscription.status': 'Status:',
    'companyRegistration.subscription.start': 'Início:',
    'companyRegistration.subscription.validity': 'Validade:',
    'companyRegistration.subscription.users': 'Usuários:',
    'companyRegistration.subscription.childCompanies': 'Empresas filhas:',
    'companyRegistration.subscription.questionnaires': 'Questionários:',
    'companyRegistration.subscription.price': 'Preço:',
    'companyRegistration.subscription.cancelSubscription': 'Cancelar Assinatura',
    'companyRegistration.subscription.noActive': 'Esta empresa não possui assinatura ativa.',
    'companyRegistration.subscription.changePlan': 'Alterar Plano',
    'companyRegistration.subscription.assignPlan': 'Atribuir Plano',
    'companyRegistration.subscription.colPlan': 'Plano',
    'companyRegistration.subscription.colUsers': 'Usuários',
    'companyRegistration.subscription.colBranches': 'Filiais',
    'companyRegistration.subscription.colQuestionnaires': 'Questionários',
    'companyRegistration.subscription.colPrice': 'Preço',
    'companyRegistration.subscription.savePlan': 'Salvar Plano',
    'companyRegistration.subscription.unlimited': 'Ilimitado',
    'companyRegistration.subscription.free': 'Gratuito',
    'companyRegistration.subscription.perMonth': '/mês',
    'companyRegistration.subscription.assignSuccess': 'Plano atribuído com sucesso.',
    'companyRegistration.subscription.assignError': 'Erro ao atribuir plano.',
    'companyRegistration.subscription.cancelConfirm': 'Confirma o cancelamento da assinatura?',
    'companyRegistration.subscription.cancelSuccess': 'Assinatura cancelada.',
    'companyRegistration.subscription.cancelError': 'Erro ao cancelar assinatura.',

    // ── Listagem de Empresas ─────────────────────────────────────────────────
    'companyList.title': 'Listagem de Empresas',
    'companyList.subtitle': 'Abra uma empresa para visualizar; use Editar/Desativar dentro do cadastro.',
    'companyList.newCompany': 'Nova Empresa',
    'companyList.loading': 'Carregando empresas...',
    'companyList.fetchError': 'Falha ao buscar empresas.',
    'companyList.connectionError': 'Erro de conexão.',
    'companyList.colRazaoSocial': 'Razão Social',
    'companyList.colNomeFantasia': 'Nome Fantasia',
    'companyList.colCnpj': 'CNPJ',
    'companyList.colTipo': 'Tipo',
    'companyList.colStatus': 'Status',
    'companyList.colAcoes': 'Ações',
    'companyList.empty': 'Nenhuma empresa cadastrada.',
    'companyList.statusAtivo': 'Ativo',
    'companyList.statusInativo': 'Inativo',
    'companyList.open': 'Abrir',

    // Tipo de empresa (rótulo de exibição — o valor salvo continua em PT)
    'tipoEmpresa.4Comply': '4Comply',
    'tipoEmpresa.Consultoria': 'Consultoria',
    'tipoEmpresa.Grupo': 'Grupo',
    'tipoEmpresa.Empresa Fim': 'Empresa Fim',
    'tipoEmpresa.Filial': 'Filial',

    // ── Menu Lateral ─────────────────────────────────────────────────────────
    'sidebar.dashboard': 'Dashboard',
    'sidebar.empresas.title': 'Empresas',
    'sidebar.estruturaOrganizacional.title': 'Estrutura Organizacional',
    'sidebar.fornecedores.title': 'Fornecedores',
    'sidebar.usuarios.title': 'Usuários',
    'sidebar.usuarios.perfisAcesso': 'Perfis de Acesso',
    'sidebar.pessoas.title': 'Pessoas',
    'sidebar.perguntas.title': 'Perguntas',
    'sidebar.questionarios.title': 'Questionários',
    'sidebar.frameworks.title': 'Frameworks',
    'sidebar.dominiosControle': 'Domínios de Controle',
    'sidebar.relatorios': 'Relatórios',
    'sidebar.cadastrosAuxiliares.title': 'Cadastros Auxiliares',
    'sidebar.cadastrosAuxiliares.tipoEmpresa': 'Tipo da Empresa',
    'sidebar.cadastrosAuxiliares.ramoAtuacao': 'Ramo de Atuação',
    'sidebar.cadastrosAuxiliares.regulamentacaoSetorial': 'Regulamentação Setorial',
    'sidebar.cadastrosAuxiliares.tipoEndereco': 'Tipo do Endereço',
    'sidebar.cadastrosAuxiliares.diretorias': 'Diretorias',
    'sidebar.cadastrosAuxiliares.gerencias': 'Gerências',
    'sidebar.cadastrosAuxiliares.departamentos': 'Departamentos',
    'sidebar.cadastrosAuxiliares.tipoPessoa': 'Tipo de Pessoa',
    'sidebar.cadastrosAuxiliares.tipoUsuario': 'Tipo do Usuário',
    'sidebar.cadastrosAuxiliares.escopoQuestionario': 'Escopo de Questionário',
    'sidebar.cadastrosAuxiliares.classificacaoConformidade': 'Classificação de Conformidade',
    'sidebar.action.cadastrarNova': 'Cadastrar Nova',
    'sidebar.action.cadastrarNovo': 'Cadastrar Novo',
    'sidebar.action.listarEditar': 'Listar / Editar',

    // Departamentos (rótulo de exibição — o valor salvo continua em PT)
    'departamento.Tecnologia da Informação': 'Tecnologia da Informação',
    'departamento.Privacidade e Proteção de Dados': 'Privacidade e Proteção de Dados',
    'departamento.Segurança da Informação': 'Segurança da Informação',
    'departamento.Financeiro': 'Financeiro',
    'departamento.Jurídico': 'Jurídico',
    'departamento.Compliance': 'Compliance',
    'departamento.Recursos Humanos': 'Recursos Humanos',
    'departamento.Operações': 'Operações',
    'departamento.Comercial': 'Comercial',
    'departamento.Outro': 'Outro',
  },

  es: {
    // ── Login ──────────────────────────────────────────────────────────────
    'login.title': 'Iniciar sesión',
    'login.subtitle': 'Accede al panel de cumplimiento de tu empresa.',
    'login.usernameLabel': 'Usuario',
    'login.passwordLabel': 'Contraseña',
    'login.submitButton': 'Entrar',
    'login.or': 'o',
    'login.forgotPassword': 'Olvidé mi contraseña',
    'login.errorUsernameRequired': 'El usuario es obligatorio.',
    'login.errorPasswordRequired': 'La contraseña es obligatoria.',
    'login.errorPasswordMinLength': 'La contraseña debe tener al menos 3 caracteres.',
    'login.errorInvalidCredentials': 'Usuario o contraseña inválidos.',
    'login.errorConnection': 'Error al conectar con el servidor. Verifique que el backend esté en ejecución.',
    'login.errorGoogle': 'No fue posible iniciar sesión con Google.',
    'login.brand': '4HC - Four Hands Group',
    'login.brandSub': '4Comply',
    'login.eyebrow': 'escaneo de cumplimiento activo',
    'login.heroTitle': 'Cumplimiento de la LGPD monitoreado en tiempo real.',
    'login.heroText': 'Supervise proveedores, contratos y cuestionarios de evaluación en un solo panel, con un registro de auditoría completo en cada etapa.',
    'login.trust.tls': 'TLS 1.3',
    'login.trust.lgpd': 'CONFORME A LA LGPD',
    'login.trust.audited': 'SESIÓN AUDITADA',
    'login.langSwitcher.label': 'Idioma',

    // ── Registro de Empresas ─────────────────────────────────────────────────
    'companyRegistration.titleNew': 'Registro de Empresa',
    'companyRegistration.titleEdit': 'Editar Empresa',
    'companyRegistration.titleView': 'Visualización de Empresa',
    'companyRegistration.stepLabel': 'Paso {{step}} de {{total}}',
    'companyRegistration.readOnlyAlert': 'Modo solo lectura. Haga clic en "Editar" para modificar los datos o en "Desactivar" para inactivar esta empresa.',
    'companyRegistration.inactiveAlertBefore': 'Esta empresa está ',
    'companyRegistration.inactiveAlertBold': 'inactiva',
    'companyRegistration.inactiveAlertAfter': ' — no se permiten cambios ni movimientos. Si necesita reactivarla, el usuario DPO Master debe abrir un ticket.',

    'companyRegistration.tabs.dados': 'Datos',
    'companyRegistration.tabs.contatos': 'Contactos',
    'companyRegistration.tabs.enderecos': 'Direcciones',
    'companyRegistration.tabs.licencas': 'Licencias',
    'companyRegistration.tabs.assinatura': 'Suscripción',
    'companyRegistration.tabs.dpo': 'Administrador',

    'companyRegistration.buttons.save': 'Guardar',
    'companyRegistration.buttons.backToList': 'Volver al listado',
    'companyRegistration.buttons.edit': 'Editar',
    'companyRegistration.buttons.deactivate': 'Desactivar',
    'companyRegistration.buttons.cancel': 'Cancelar',

    'companyRegistration.deactivateModal.title': 'Desactivar Empresa',
    'companyRegistration.deactivateModal.text': 'Las empresas inactivas no podrán sufrir cambios ni movimientos. Indique el motivo de la desactivación.',
    'companyRegistration.deactivateModal.justificativaLabel': 'Motivo',
    'companyRegistration.deactivateModal.justificativaPlaceholder': 'Describa el motivo de la desactivación...',
    'companyRegistration.deactivateModal.confirm': 'Desactivar',

    'companyRegistration.notify.razaoSocialRequired': 'La razón social es obligatoria.',
    'companyRegistration.notify.cnpjInvalid': 'CNPJ inválido. Por favor, verifique el número informado.',
    'companyRegistration.notify.dpoNomeRequired': 'El nombre del Administrador es obligatorio cuando se completa este campo.',
    'companyRegistration.notify.dpoEmailRequired': 'El correo del Administrador es obligatorio cuando se completa este campo.',
    'companyRegistration.notify.updateSuccess': '¡Empresa actualizada con éxito!',
    'companyRegistration.notify.createSuccess': '¡Empresa creada con éxito! ID: {{id}}',
    'companyRegistration.notify.cnpjDuplicate': 'Este CNPJ ya está registrado.',
    'companyRegistration.notify.saveError': 'Error al guardar la empresa: {{error}}',
    'companyRegistration.notify.connectionError': 'Error de conexión al intentar guardar la empresa.',
    'companyRegistration.notify.deactivateSuccess': '¡Empresa desactivada con éxito!',
    'companyRegistration.notify.deactivateError': 'Error al desactivar la empresa.',
    'companyRegistration.notify.deactivateConnectionError': 'Error de conexión al desactivar.',

    'companyRegistration.data.codigoId': 'Código ID Empresa',
    'companyRegistration.data.codigoIdPlaceholder': 'Se generará automáticamente al guardar',
    'companyRegistration.data.tipo': 'Tipo',
    'companyRegistration.data.tipoPlaceholder': 'Buscar en el Registro Auxiliar de Tipos de Empresa',
    'companyRegistration.data.cnpj': 'CNPJ',
    'companyRegistration.data.cnpjInvalidFeedback': 'Por favor, introduzca un CNPJ válido',
    'companyRegistration.data.razaoSocial': 'Razón Social',
    'companyRegistration.data.nomeFantasia': 'Nombre Comercial',
    'companyRegistration.data.inscricaoEstadual': 'Inscripción Estatal',
    'companyRegistration.data.inscricaoMunicipal': 'Inscripción Municipal',
    'companyRegistration.data.ramoAtuacao': 'Sectores de Actividad',
    'companyRegistration.data.ramoAtuacaoPlaceholder': 'Buscar en el Registro Auxiliar de Sectores de Actividad',
    'companyRegistration.data.regulamentacao': 'Regulación Sectorial',
    'companyRegistration.data.regulamentacaoPlaceholder': 'Buscar en el Registro Auxiliar de Regulaciones',
    'companyRegistration.data.dadosComplementares': 'Datos Complementarios',
    'companyRegistration.data.createdSuccess': '¡Registrado con éxito!',
    'companyRegistration.data.createError': 'Error al registrar.',
    'companyRegistration.data.connectionError': 'Error de conexión al registrar.',

    'companyRegistration.contacts.nome': 'Nombre',
    'companyRegistration.contacts.email': 'Correo electrónico',
    'companyRegistration.contacts.telefone': 'Teléfono',
    'companyRegistration.contacts.departamento': 'Departamento',
    'companyRegistration.contacts.selecione': 'Seleccione',
    'companyRegistration.contacts.cargo': 'Cargo',
    'companyRegistration.contacts.saveChanges': 'Guardar Cambios',
    'companyRegistration.contacts.addContact': 'Agregar Contacto',
    'companyRegistration.contacts.cancel': 'Cancelar',
    'companyRegistration.contacts.tableActions': 'Acciones',
    'companyRegistration.contacts.edit': 'Editar',
    'companyRegistration.contacts.remove': 'Eliminar',

    'companyRegistration.addresses.tipoEndereco': 'Tipo de Dirección',
    'companyRegistration.addresses.tipoEnderecoPlaceholder': 'Buscar en el Registro Auxiliar de Tipo de Dirección',
    'companyRegistration.addresses.cep': 'Código Postal',
    'companyRegistration.addresses.endereco': 'Dirección',
    'companyRegistration.addresses.enderecoPlaceholder': 'Se completa automáticamente con el código postal',
    'companyRegistration.addresses.numero': 'Número',
    'companyRegistration.addresses.bairro': 'Barrio',
    'companyRegistration.addresses.cidade': 'Ciudad',
    'companyRegistration.addresses.estado': 'Provincia/Estado',
    'companyRegistration.addresses.saveChanges': 'Guardar Cambios',
    'companyRegistration.addresses.addAddress': 'Agregar Dirección',
    'companyRegistration.addresses.cancel': 'Cancelar',
    'companyRegistration.addresses.tableActions': 'Acciones',
    'companyRegistration.addresses.edit': 'Editar',
    'companyRegistration.addresses.remove': 'Eliminar',
    'companyRegistration.addresses.cepNotFound': 'Código postal no encontrado.',
    'companyRegistration.addresses.cepError': 'No fue posible consultar el código postal ahora. Complete la dirección manualmente.',
    'companyRegistration.addresses.selectCompanyFirst': 'Seleccione una empresa antes de registrar.',
    'companyRegistration.addresses.createdSuccess': '¡Registrado con éxito!',
    'companyRegistration.addresses.createError': 'Error al registrar.',
    'companyRegistration.addresses.connectionError': 'Error de conexión al registrar.',

    'companyRegistration.dpo.alertTitle': 'Administrador del Sistema',
    'companyRegistration.dpo.p1': 'Al guardar la empresa, el sistema creará automáticamente un usuario con perfil ',
    'companyRegistration.dpo.perfilAdministrador': 'Administrador',
    'companyRegistration.dpo.p2': ' vinculado al correo indicado abajo y enviará una ',
    'companyRegistration.dpo.senhaTemporaria': 'contraseña temporal',
    'companyRegistration.dpo.p3': ' a esa dirección. El Administrador usará esa contraseña para el primer acceso y, a partir de ahí, realizará los demás registros necesarios.',
    'companyRegistration.dpo.nome': 'Nombre *',
    'companyRegistration.dpo.nomePlaceholder': 'Nombre completo del Administrador',
    'companyRegistration.dpo.email': 'Correo electrónico *',
    'companyRegistration.dpo.emailPlaceholder': 'correo@empresa.com',
    'companyRegistration.dpo.emailInvalid': 'Correo electrónico inválido.',
    'companyRegistration.dpo.emailHelp': 'Este correo se usará como usuario de acceso del Administrador de la empresa.',
    'companyRegistration.dpo.telefone': 'Teléfono',
    'companyRegistration.dpo.telefonePlaceholder': '(00) 00000-0000',
    'companyRegistration.dpo.departamento': 'Departamento',
    'companyRegistration.dpo.selecione': 'Seleccione',

    'companyRegistration.licenses.readOnlyAlert': 'Visualización de solo lectura. La gestión de licencias es exclusiva del usuario 4Comply.',
    'companyRegistration.licenses.tipo': 'Tipo de Licencia',
    'companyRegistration.licenses.status': 'Estado de la Licencia',
    'companyRegistration.licenses.modulos': 'Módulos',
    'companyRegistration.licenses.servicos': 'Servicios',
    'companyRegistration.licenses.mentoria': 'Mentoría',
    'companyRegistration.licenses.ativa': 'Activa',
    'companyRegistration.licenses.inativa': 'Inactiva',
    'companyRegistration.licenses.add': 'Agregar',
    'companyRegistration.licenses.tableActions': 'Acciones',
    'companyRegistration.licenses.empty': 'No hay licencias registradas.',
    'companyRegistration.licenses.remove': 'Eliminar',

    'companyRegistration.subscription.loading': 'Cargando planes...',
    'companyRegistration.subscription.currentTitle': 'Suscripción Actual',
    'companyRegistration.subscription.plan': 'Plan:',
    'companyRegistration.subscription.status': 'Estado:',
    'companyRegistration.subscription.start': 'Inicio:',
    'companyRegistration.subscription.validity': 'Vigencia:',
    'companyRegistration.subscription.users': 'Usuarios:',
    'companyRegistration.subscription.childCompanies': 'Empresas filiales:',
    'companyRegistration.subscription.questionnaires': 'Cuestionarios:',
    'companyRegistration.subscription.price': 'Precio:',
    'companyRegistration.subscription.cancelSubscription': 'Cancelar Suscripción',
    'companyRegistration.subscription.noActive': 'Esta empresa no tiene una suscripción activa.',
    'companyRegistration.subscription.changePlan': 'Cambiar Plan',
    'companyRegistration.subscription.assignPlan': 'Asignar Plan',
    'companyRegistration.subscription.colPlan': 'Plan',
    'companyRegistration.subscription.colUsers': 'Usuarios',
    'companyRegistration.subscription.colBranches': 'Filiales',
    'companyRegistration.subscription.colQuestionnaires': 'Cuestionarios',
    'companyRegistration.subscription.colPrice': 'Precio',
    'companyRegistration.subscription.savePlan': 'Guardar Plan',
    'companyRegistration.subscription.unlimited': 'Ilimitado',
    'companyRegistration.subscription.free': 'Gratuito',
    'companyRegistration.subscription.perMonth': '/mes',
    'companyRegistration.subscription.assignSuccess': 'Plan asignado con éxito.',
    'companyRegistration.subscription.assignError': 'Error al asignar el plan.',
    'companyRegistration.subscription.cancelConfirm': '¿Confirma la cancelación de la suscripción?',
    'companyRegistration.subscription.cancelSuccess': 'Suscripción cancelada.',
    'companyRegistration.subscription.cancelError': 'Error al cancelar la suscripción.',

    // ── Listado de Empresas ─────────────────────────────────────────────────
    'companyList.title': 'Listado de Empresas',
    'companyList.subtitle': 'Abra una empresa para visualizarla; use Editar/Desactivar dentro del registro.',
    'companyList.newCompany': 'Nueva Empresa',
    'companyList.loading': 'Cargando empresas...',
    'companyList.fetchError': 'Error al buscar empresas.',
    'companyList.connectionError': 'Error de conexión.',
    'companyList.colRazaoSocial': 'Razón Social',
    'companyList.colNomeFantasia': 'Nombre Comercial',
    'companyList.colCnpj': 'CNPJ',
    'companyList.colTipo': 'Tipo',
    'companyList.colStatus': 'Estado',
    'companyList.colAcoes': 'Acciones',
    'companyList.empty': 'No hay empresas registradas.',
    'companyList.statusAtivo': 'Activo',
    'companyList.statusInativo': 'Inactivo',
    'companyList.open': 'Abrir',

    // Tipo de empresa (etiqueta de visualización — el valor guardado sigue en PT)
    'tipoEmpresa.4Comply': '4Comply',
    'tipoEmpresa.Consultoria': 'Consultoría',
    'tipoEmpresa.Grupo': 'Grupo',
    'tipoEmpresa.Empresa Fim': 'Empresa Final',
    'tipoEmpresa.Filial': 'Sucursal',

    // ── Menú Lateral ─────────────────────────────────────────────────────────
    'sidebar.dashboard': 'Panel',
    'sidebar.empresas.title': 'Empresas',
    'sidebar.estruturaOrganizacional.title': 'Estructura Organizacional',
    'sidebar.fornecedores.title': 'Proveedores',
    'sidebar.usuarios.title': 'Usuarios',
    'sidebar.usuarios.perfisAcesso': 'Perfiles de Acceso',
    'sidebar.pessoas.title': 'Personas',
    'sidebar.perguntas.title': 'Preguntas',
    'sidebar.questionarios.title': 'Cuestionarios',
    'sidebar.frameworks.title': 'Frameworks',
    'sidebar.dominiosControle': 'Dominios de Control',
    'sidebar.relatorios': 'Informes',
    'sidebar.cadastrosAuxiliares.title': 'Registros Auxiliares',
    'sidebar.cadastrosAuxiliares.tipoEmpresa': 'Tipo de Empresa',
    'sidebar.cadastrosAuxiliares.ramoAtuacao': 'Sector de Actividad',
    'sidebar.cadastrosAuxiliares.regulamentacaoSetorial': 'Regulación Sectorial',
    'sidebar.cadastrosAuxiliares.tipoEndereco': 'Tipo de Dirección',
    'sidebar.cadastrosAuxiliares.diretorias': 'Direcciones',
    'sidebar.cadastrosAuxiliares.gerencias': 'Gerencias',
    'sidebar.cadastrosAuxiliares.departamentos': 'Departamentos',
    'sidebar.cadastrosAuxiliares.tipoPessoa': 'Tipo de Persona',
    'sidebar.cadastrosAuxiliares.tipoUsuario': 'Tipo de Usuario',
    'sidebar.cadastrosAuxiliares.escopoQuestionario': 'Alcance de Cuestionario',
    'sidebar.cadastrosAuxiliares.classificacaoConformidade': 'Clasificación de Conformidad',
    'sidebar.action.cadastrarNova': 'Registrar Nueva',
    'sidebar.action.cadastrarNovo': 'Registrar Nuevo',
    'sidebar.action.listarEditar': 'Listar / Editar',

    // Departamentos (etiqueta de visualización — el valor guardado sigue en PT)
    'departamento.Tecnologia da Informação': 'Tecnología de la Información',
    'departamento.Privacidade e Proteção de Dados': 'Privacidad y Protección de Datos',
    'departamento.Segurança da Informação': 'Seguridad de la Información',
    'departamento.Financeiro': 'Finanzas',
    'departamento.Jurídico': 'Jurídico',
    'departamento.Compliance': 'Cumplimiento',
    'departamento.Recursos Humanos': 'Recursos Humanos',
    'departamento.Operações': 'Operaciones',
    'departamento.Comercial': 'Comercial',
    'departamento.Outro': 'Otro',
  },
};
